var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "device-is-disabled-banner",
      attrs: { "data-cy": "device-is-disabled-banner" },
    },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("vwc-icon", {
            staticClass: "icon vvd-scheme-alternate",
            attrs: { type: "warning-solid" },
          }),
          _c("div", { staticClass: "text-container" }, [
            _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
            _c("div", { staticClass: "text" }, [_vm._v(_vm._s(_vm.text))]),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }